import TrelloModel from 'app/scripts/models/internal/trello-model.coffee';

class Sticker extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'Sticker';
  }
}
Sticker.initClass();

export { Sticker };
